import { styled } from "goober";
import { Spinner } from "../Spinner";
import { Text } from "../Text";
import { DateBadge } from "./transcriptStyles";

const Row = styled("div")`
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  padding: 8px 0;
`;

const Badge = styled(DateBadge)`
  gap: 6px;
`;

export function HistoryLoading() {
  return (
    <Row role="status">
      <Badge>
        <Spinner size={10} />
        <Text variant="text-small" color="var(--text-secondary)">
          Loading older messages…
        </Text>
      </Badge>
    </Row>
  );
}
